<button [ngClass]="{ 'hvac-browse-tile-totaline-fill-color': isTotaline, 'hvac-browse-tile-totaline-fill-none': category.urn === 'PIMRC-5' }" class="hvac-browse-tile hvac-browse-category-tile" (click)="browseTo(category)">
    <utc-svg class="hvac-browse-tile-category-icon" [src]="icon"></utc-svg>
    <p class="hvac-label-sm">{{ category.name }}</p>
</button>
